import { useEffect, useState } from "react";
import Lenis from "lenis";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import { Preloader } from "@/components/Preloader";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { MarqueeStrip } from "@/components/MarqueeStrip";
import { About } from "@/components/About";
import { Capabilities } from "@/components/Capabilities";
import { Products } from "@/components/Products";
import { Infrastructure } from "@/components/Infrastructure";
import { Clients } from "@/components/Clients";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";

function App() {
    const [lenis, setLenis] = useState(null);
    const [ready, setReady] = useState(false);

    useEffect(() => {
        const instance = new Lenis({ duration: 1.2, smoothWheel: true });
        setLenis(instance);
        let rafId;
        const loop = (time) => {
            instance.raf(time);
            rafId = requestAnimationFrame(loop);
        };
        rafId = requestAnimationFrame(loop);
        const timer = setTimeout(() => setReady(true), 1700);
        return () => {
            cancelAnimationFrame(rafId);
            instance.destroy();
            clearTimeout(timer);
        };
    }, []);

    return (
        <div className="bg-ink font-body text-zinc-100 antialiased">
            <AnimatePresence>{!ready && <Preloader />}</AnimatePresence>
            <div className="noise-overlay" aria-hidden="true" />
            <Nav lenis={lenis} />
            <main>
                <Hero ready={ready} lenis={lenis} />
                <MarqueeStrip />
                <About />
                <Capabilities />
                <Products />
                <Infrastructure />
                <Clients />
                <Contact />
            </main>
            <Footer lenis={lenis} />
            <WhatsAppButton />
            <Toaster theme="dark" position="bottom-left" />
        </div>
    );
}

export default App;
